import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-pdf-display',
  standalone: true,
  imports: [],
  templateUrl: './pdf-display.component.html',
  styleUrls: ['./pdf-display.component.scss']
})
export class PdfDisplayComponent implements OnInit {
  pdfUrl: string;
  safePdfUrl: SafeResourceUrl;

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const pdfKey = params.get('pdfKey'); // Assuming you pass the PDF key as a route parameter
      this.pdfUrl = `https://ctm-public.s3.eu-west-2.amazonaws.com/${pdfKey}.pdf`

      // Sanitize the PDF URL to prevent security risks
      this.safePdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.pdfUrl);
    });
  }
}

